import { render, staticRenderFns } from "./MedicalExpenses.vue?vue&type=template&id=3c515190"
import script from "./MedicalExpenses.vue?vue&type=script&lang=js"
export * from "./MedicalExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports